module.exports = __webpack_public_path__ + "static/media/processbanner@3x.cbdd19ea.png";